var map = {
	"./about.png": 5869,
	"./all.png": 3323,
	"./allGames.png": 5474,
	"./appCode.png": 9996,
	"./back.png": 9713,
	"./btn1.png": 5457,
	"./btn2.png": 4346,
	"./check.png": 210,
	"./collection.png": 980,
	"./collection1.png": 103,
	"./contact.png": 7022,
	"./copy.png": 2907,
	"./customer.png": 6204,
	"./download.png": 300,
	"./edit.png": 8980,
	"./empty.png": 8205,
	"./empty2.png": 1659,
	"./espinlogo.png": 3562,
	"./exit.png": 9048,
	"./faq.png": 8582,
	"./fb.png": 9028,
	"./friends.png": 425,
	"./fullscreen.png": 335,
	"./gcollect.png": 6015,
	"./gicollect.png": 9244,
	"./google.png": 149,
	"./hot.png": 3115,
	"./indialogo.png": 2558,
	"./jackpot.png": 8936,
	"./kf.png": 2923,
	"./lang.png": 5048,
	"./left.png": 7463,
	"./level.png": 4480,
	"./loginUser.png": 8872,
	"./logo.png": 1865,
	"./more.png": 7975,
	"./nav_account.png": 1249,
	"./nav_account1.png": 8124,
	"./nav_home.png": 8099,
	"./nav_home1.png": 258,
	"./nav_invite.png": 9553,
	"./nav_invite1.png": 9340,
	"./nav_promosi.png": 5741,
	"./nav_promosi1.png": 5056,
	"./nav_wallet.png": 3550,
	"./nav_wallet1.png": 4636,
	"./news.png": 2821,
	"./notice.png": 7652,
	"./password.png": 6927,
	"./pccontact.png": 4511,
	"./pcdwn.png": 1540,
	"./pointer.png": 8105,
	"./profile.png": 1933,
	"./provider.png": 6835,
	"./providers.png": 7824,
	"./pwd.png": 8491,
	"./right.png": 776,
	"./sign-out.png": 9680,
	"./tel.png": 9145,
	"./telegram.png": 3173,
	"./toHome.png": 1614,
	"./top.png": 5315,
	"./upload.png": 1491,
	"./wallet-w.png": 35,
	"./wallet.png": 6643,
	"./wimg.png": 5976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4131;